import { render, staticRenderFns } from "./AnalyteResultTable.vue?vue&type=template&id=798595e4"
import script from "./AnalyteResultTable.vue?vue&type=script&lang=js"
export * from "./AnalyteResultTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports